import { isValid, parseISO } from 'date-fns'

import { ProfileMetadata, UserStatus } from '../../types/user/userProfile'
import { displayDate } from '../dateUtils'

export const userStatusI18nKey = (status: UserStatus): string => {
  switch (status) {
    case UserStatus.REGISTERED:
      return 'users.status.registered'
    case UserStatus.PENDING_CONFIRMATION:
      return 'users.status.pending-confirmation'
    case UserStatus.MANAGED:
      return 'users.status.managed'
  }
}

const UNAVAILABLE_DATE = '—'

export const getUserFullName = (
  user: Pick<ProfileMetadata, 'firstName' | 'lastName'>
): string =>
  [user.firstName, user.lastName]
    .map(name => name?.trim())
    .filter(Boolean)
    .join(' ')

// Full name, or the email when the user has not filled in a name.
export const getUserDisplayName = (
  user: Pick<ProfileMetadata, 'firstName' | 'lastName' | 'email'>
): string => getUserFullName(user) || user.email

export const formatUserJoinedAt = (
  joinedAt: string | null | undefined,
  language: string
): string => {
  if (!joinedAt) {
    return UNAVAILABLE_DATE
  }

  const parsedDate = parseISO(joinedAt)

  if (!isValid(parsedDate)) {
    return UNAVAILABLE_DATE
  }

  return displayDate(joinedAt, language)
}
